import CFG from '../gameLoopConfig.json';
import { PLAYER_SIZE, WORLD_HEIGHT } from '../../../constants';
import { rollChestItem } from '../../../data/items';

const GD = CFG.groundDrops;

export function checkChestCollection(s, setChestLootOptions, setGameState) {
  for (let ci = (s.chests ?? []).length - 1; ci >= 0; ci--) {
    const chest = s.chests[ci];
    if (s.player.x < chest.x + chest.size && s.player.x + PLAYER_SIZE > chest.x &&
        s.player.y < chest.y + chest.size && s.player.y + PLAYER_SIZE > chest.y) {
      s.chests.splice(ci, 1);
      s.isTierBossChest = false;
      const plLevel = (s.score ?? 0) / 1000;
      const loot = [rollChestItem(plLevel), rollChestItem(plLevel), rollChestItem(plLevel)];
      setChestLootOptions(loot);
      setGameState('chestopen');
      return true; // stop frame
    }
  }
  return false;
}

export function updateGroundDrops(s, dt, terrainDy, pcx, pcy) {
  if (!s.groundDrops || s.groundDrops.length === 0) return;
  for (let gi = s.groundDrops.length - 1; gi >= 0; gi--) {
    const gd   = s.groundDrops[gi];
    const half = gd.size / 2;
    gd.y += terrainDy;
    if (gd.y > WORLD_HEIGHT + 30) { s.groundDrops.splice(gi, 1); continue; }

    const gdcx = gd.x + half;
    const gdcy = gd.y + half;
    const ddx  = pcx - gdcx;
    const ddy  = pcy - gdcy;
    const dist = Math.hypot(ddx, ddy);

    if (dist < GD.attractRadius) {
      if (dist > 0) {
        const step = Math.min(GD.attractSpeed * dt, dist);
        gd.x += (ddx / dist) * step;
        gd.y += (ddy / dist) * step;
      }
      if (dist <= half + 4) {
        s.groundDrops.splice(gi, 1);
        if (gd.type === 'xp') {
          const tierXpBonus = Math.floor((s.currentTier ?? 0) / 10) * 10;
          s.xp += ((s.xpPerKill ?? 1) + tierXpBonus) * (s.activeModifier?.xpMult ?? 1);
        } else if (gd.type === 'item' && gd.item) {
          s.droppedItems.push(gd.item);
        }
      }
    }
  }
  if (s.groundDrops.length > CFG.maxGroundDrops) s.groundDrops.length = CFG.maxGroundDrops;
}
